import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { CustomerConfirmDistinctResponse } from '@lio/api-types';
import { customerQueryKey } from './keys';

/**
 * Confirm that a customer flagged as a potential duplicate (matchState
 * NeedsReview) is in fact distinct. Transitions the customer to Confirmed
 * without merging it into another customer. Requires a resolution reason/note.
 */
export const useConfirmDistinct = () => {
  const client = useClient();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ customerId, reason }: { customerId: string; reason: string }) =>
      client
        .post(`customer/${customerId}/confirm-distinct`, {
          json: { reason },
        })
        .json<CustomerConfirmDistinctResponse>(),
    onSuccess: (_, { customerId }) => {
      queryClient.invalidateQueries({
        queryKey: customerQueryKey.getCustomer(customerId),
      });
      queryClient.invalidateQueries({
        queryKey: [...customerQueryKey._customer, 'list'],
      });
      queryClient.invalidateQueries({
        queryKey: customerQueryKey.getStatusHistory(customerId),
      });
    },
  });

  return {
    confirmDistinct: mutation.mutateAsync,
    isPending: mutation.isPending,
  };
};
